import LocomotiveScroll from 'locomotive-scroll';
const $ = jQuery;

export default class Scroll {
	static init(){
		const scrollContainer = document.querySelector('[data-scroll-container]');
		new Scroll(scrollContainer);
	}

	constructor(scrollContainer){

		this.scrollContainer = scrollContainer;

        this.scroll = new LocomotiveScroll({
            el: this.scrollContainer,
            smooth: true,
			getDirection: true,
        });

		$(document).on('gform_confirmation_loaded', () => {
			this.scroll.update();
        });

		document.addEventListener('update-scroll', () => {
			this.scroll.update();
		});

		const navBar = document.querySelector('.c-header');
		const home = document.querySelector('.home');
		const isMobile = window.matchMedia('only screen and (max-width: 760px)').matches;

		this.scroll.on('scroll', (position) => {
			if (isMobile && position.scroll.y > 200) {
				if (position.direction === 'up') {
					navBar.classList.add('is-visible');
				}
				if (position.direction === 'down') {
					navBar.classList.remove('is-visible');
				}
			}

			if (isMobile && home) {
				if (position.scroll.y > 200) {
					navBar.classList.add('has-background--white');
				} else {
					navBar.classList.remove('has-background--white');
				}
			}

			if(!isMobile && home) {
				if (position.scroll.y > 600) {
					navBar.classList.add('has-background--white');
				} else {
					navBar.classList.remove('has-background--white');
				}
			}
		});
	}
}
